import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/** Floating Onyx advisor — slim pill, never dominating. */
export default function OnyxWidgetMount() {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const loc = useLocation();
  const url = (import.meta.env.VITE_CHATBOT_WIDGET_URL as string | undefined) || "";

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  if (loc.pathname.startsWith("/apply")) return null;
  if (dismissed) return null;

  return (
    <>
      {!open && (
        <button
          aria-label="Ask Onyx"
          onClick={() => setOpen(true)}
          className="fixed z-[60] bottom-24 md:bottom-6 right-4 md:right-6 group"
        >
          <div
            className="flex items-center gap-2.5 px-4 h-[50px] rounded-full border transition-colors duration-300"
            style={{
              background: "rgba(20,17,13,0.85)",
              borderColor: "var(--rule)",
              backdropFilter: "blur(14px)",
              WebkitBackdropFilter: "blur(14px)",
            }}
          >
            <span className="relative flex items-center">
              <span className="w-1.5 h-1.5 bg-gold rounded-full" style={{ boxShadow: "0 0 8px var(--gold)", animation: "status-pulse 2s ease-in-out infinite" }} />
            </span>
            <span className="font-mono text-[10.5px] tracking-[0.18em] uppercase text-dim group-hover:text-bone transition-colors">Ask Onyx</span>
          </div>
        </button>
      )}

      {open && (
        <div className="fixed inset-0 md:inset-auto md:bottom-6 md:right-6 md:w-[400px] md:h-[580px] z-[70] surface-card flex flex-col shadow-[0_24px_60px_rgba(0,0,0,0.65)]">
          <div className="flex items-center justify-between px-4 py-3 border-b border-soft bg-room">
            <div>
              <div className="mono-label mono-label-gold">Onyx</div>
              <div className="text-sm text-bone font-display mt-0.5">Ask before you apply</div>
            </div>
            <div className="flex gap-1">
              <button onClick={() => setOpen(false)} className="btn btn-ghost !min-h-[36px] !px-3 !text-[10.5px]">Close</button>
              <button onClick={() => { setDismissed(true); setOpen(false); }} aria-label="Dismiss" className="btn btn-ghost !min-h-[36px] !px-2 !text-[10.5px]">×</button>
            </div>
          </div>
          <div className="flex-1 overflow-hidden bg-room">
            {url ? (
              <iframe title="Onyx" src={url} className="w-full h-full" />
            ) : (
              <div className="h-full flex flex-col items-center justify-center gap-4 p-8 text-center">
                <span className="mono-label mono-label-gold">Advisor</span>
                <p className="text-bone font-display text-xl leading-tight">Got a question before you apply?</p>
                <p className="text-dim text-sm">Onyx will answer it directly. In the meantime, head straight to the application.</p>
                <a href="/apply" className="btn btn-primary mt-4">Apply for a call →</a>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
